import { Alert } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import CuentaCorrienteDetalle from './CuentaCorrienteDetalle';

/**
 * Shortcut para admin_empresa: muestra el detalle de SU propia cuenta
 * corriente sin selector. Patrón #012 (la ruta /cuenta-corriente para empresa
 * redirige acá).
 */
export default function MiCuentaCorriente() {
  const { effectiveEmpresaId } = useAuth();

  if (!effectiveEmpresaId) {
    return (
      <Alert severity="error">
        No se pudo identificar tu empresa. Cerrá sesión y volvé a ingresar.
      </Alert>
    );
  }

  return (
    <CuentaCorrienteDetalle
      empresaIdProp={effectiveEmpresaId}
      hideVolver
    />
  );
}
